module.exports = __webpack_public_path__ + "static/media/logo-square.00ac6ca2.jpg";